import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette, fontSizes, contentWidth }: Theme) => ({
  root: {
    position: 'relative',
    height: 'calc(100vh - 5rem)',
    maxHeight: 'fit-content',
  },
  wrapper: {
    position: 'relative',
    marginTop: '-7.375rem',
  },
  title: {
    width: 'fit-content',
    margin: 0,
    padding: '0.375rem',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
    borderTopRightRadius: '0.5rem',
    background: palette.common.white,
    fontSize: fontSizes.xxl,
    lineHeight: 1.35,

  },
  titleWrapper: {
    position: 'relative',
    zIndex: 3,
    maxWidth: contentWidth,
    margin: '0 auto',
    padding: '2rem 1.5rem 0',
    '& button.text': {
      marginBottom: 0,
      padding: '0.375rem',
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      background: palette.common.white,
    },
  },
}));
